const getVehicleTypes = intl => {
    return [
        {
            text: intl.translate('ap_forms_vehicletype_vehicle_type_car'),
            value: 'CAR'
        },
        {
            text: intl.translate('ap_forms_vehicletype_vehicle_type_caddy'),
            value: 'CADDY'
        },
        {
            text: intl.translate('ap_forms_vehicletype_vehicle_type_car_station_wagon'),
            value: 'CAR_STATION_WAGON'
        },
        {
            text: intl.translate('ap_forms_vehicletype_vehicle_type_pickup'),
            value: 'PICKUP'
        },
        {
            text: intl.translate('ap_forms_vehicletype_vehicle_type_suv'),
            value: 'SUV'
        },
        {
            text: intl.translate('ap_forms_vehicletype_vehicle_type_multivan'),
            value: 'MULTIVAN'
        },
        {
            text: intl.translate('ap_forms_vehicletype_vehicle_type_ape'),
            value: 'APE'
        },
        {
            text: intl.translate('ap_forms_vehicletype_vehicle_type_van'),
            value: 'VAN'
        },
        {
            text: intl.translate('ap_forms_vehicletype_vehicle_type_tractor'),
            value: 'TRACTOR'
        },
        {
            text: intl.translate('ap_forms_vehicletype_vehicle_type_heavyweight_truck'),
            value: 'HEAVYWEIGHT_TRUCK'
        },
        {
            text: intl.translate('ap_forms_vehicletype_vehicle_type_truck_with_trailer'),
            value: 'TRUCK_WITH_TRAILER'
        },
        {
            text: intl.translate('ap_forms_vehicletype_vehicle_type_bike'),
            value: 'BIKE'
        },
        {
            text: intl.translate('ap_forms_vehicletype_vehicle_type_bus'),
            value: 'BUS'
        },
        {
            text: intl.translate('ap_forms_vehicletype_vehicle_type_trailer'),
            value: 'TRAILER'
        }
    ]
}

const getAssetTypes = intl => {
    return [
        {
            text: intl.translate('ap_forms_vehicletype_vehicle_type_trailer'),
            value: 'TRAILER'
        },
        {
            text: intl.translate('ap_forms_assettype_asset_type_machinery'),
            value: 'MACHINERY'
        },
        {
            text: intl.translate('ap_forms_assettype_asset_type_equipment'),
            value: 'EQUIPMENT'
        }
    ]
}

export { getAssetTypes, getVehicleTypes }
